import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../components/DefaultEdit";
import {EmployeeForm} from "./EmployeeForm";

export const EmployeeEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <EmployeeForm />
    </DefaultEdit>
  );
};
